import {AfterViewInit, Component, HostBinding, Input, OnInit, TemplateRef, ViewChild, inject} from '@angular/core';
import {ClsConfig} from '../../../util/cls-config';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import {
  IGridEditDoneEventArgs, IGridEditEventArgs, IgxColumnComponent, IgxExcelExporterService, IgxPdfExporterService,
  IgxGridCell, IgxGridStateDirective, RowType
} from '@infragistics/igniteui-angular/grids/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxRippleDirective, IgxRippleModule, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import {IGX_INPUT_GROUP_DIRECTIVES, IgxInputGroupComponent} from '@infragistics/igniteui-angular/input-group';
import { IGX_ACTION_STRIP_DIRECTIVES, IgxActionStripModule } from '@infragistics/igniteui-angular/action-strip';
import {ClsUtil} from '../../../util/cls-util';
import {MasOpcionesGridComponent} from '../../util/controles/mas-opciones-grid/mas-opciones-grid.component';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {ClsObjCrudCatalogos} from '../../../clases-pu/02-catalogos/cls-obj-crud-catalogos';
import {EnumMasOpciones} from '../../../core/models/enum/enum-mas-opciones';
import {INeodataGridCell, INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {EnumMCGenerales} from '../../../core/models/enum/enum-menu-contextual';
import {EnumNombresGrids} from '../../../core/models/enum/enum-nombres-grids';
import {ClsObjConfiguracionGrid} from '../../../clases-pu/util/cls-obj-configuracion-grid';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {EnumTresPuntos} from '../../../core/models/enum/enum-tres-puntos';
import {ClsObjCopiado} from '../../../clases-pu/01-presupuesto/copiado/cls-obj-copiado';
import {DetallePegadoComponent} from '../../util/ventanas/detalle-pegado/detalle-pegado.component';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {ClsObjPegado} from 'src/app/clases-pu/99-herramientas/pegado/cls-obj-pegado';
import {TranslateModule} from '@ngx-translate/core';
import {ContextMenuGenericoComponent} from '../../util/controles/context-menu-generico/context-menu-generico.component';
import {UppercaseDirective} from '../../../core/directivas/uppercase.directive';
import {FormsModule} from '@angular/forms';
import {PasteHandlerNeodataDirective} from '../../../core/directivas/paste-handler-neodata.directive';
import {ClsTipoLicitaciones} from 'src/app/core/models/cls-catalogos';
import {ClsColDetallePegado} from 'src/app/core/models/cls-pegado';
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../core/pipes/summary-pipe-neo.pipe";
import {CrearComponenteDinamicoService} from "../../../core/services/crear-componente-dinamico.service";

@Component({
  selector: 'app-tiposdelicitaciones',
  templateUrl: './tipos-de-licitaciones.component.html',
  styleUrls: ['./tipos-de-licitaciones.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    IgxIconComponent,
    MasOpcionesGridComponent,
    PasteHandlerNeodataDirective,
    IGX_INPUT_GROUP_DIRECTIVES,
    IgxButtonModule,
    IgxButtonDirective,
    IgxActionStripModule,
    IGX_ACTION_STRIP_DIRECTIVES,
    FormsModule,
    UppercaseDirective,
    IgxTextSelectionDirective,
    IgxFocusDirective,
    IgxRippleModule,
    IgxRippleDirective,
    ContextMenuGenericoComponent,
    SummaryPipeNeoPipe,
    IgxInputGroupComponent
  ],
  providers: [SummaryPipeNeoPipe]
})
export class TiposDeLicitacionesComponent extends ClsConfig implements OnInit, AfterViewInit {
  private infPpto = inject(AppPresupuestosService);
  private tipoMsg = inject(TipoMensajesService);
  private summaryPipe = inject(SummaryPipeNeoPipe);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridTiposDeLicitaciones', {read: IgxGridComponent, static: true})
  public gridTiposDeLicitaciones: IgxGridComponent;
  @ViewChild('masOpcionesG', {read: MasOpcionesGridComponent, static: true})
  public masOpcionesG: MasOpcionesGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;
  @Input()
  public modoEdicion = true;
  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  public errorAlCargar: boolean;
  public dataTiposDeLicitaciones: ClsTipoLicitaciones[] = [];
  public activarBotones = false;
  // mostrar actionStrip
  public showActionStrip = true;
  // clase catalogos
  public mObjCRUDCatalogos: ClsObjCrudCatalogos = new ClsObjCrudCatalogos();
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  private mObjCopiado: ClsObjCopiado = new ClsObjCopiado();
  private mObjPegado: ClsObjPegado = new ClsObjPegado();
  // menucontextual
  public verContextMenu = false;
  public contextmenuX = 0;
  public contextmenuY = 0;
  public cellMenuContextaul: IgxGridCell;
  public menus: INeodataMenu[] = [];
  public lengthMenu: number;
  public subMenusOpciones: any[];
  public sizeMenu = '';
  // CONFIGGRIDS: definir cada ng-Template que tengamos en el HTML
  @ViewChild('tipoLicitacionHeaderTemplate', {static: true}) public tipoLicitacionHeaderTemplate: TemplateRef<any>;
  @ViewChild('tipoLicitacionEditorTemplate', {static: true}) public tipoLicitacionEditorTemplate: TemplateRef<any>;
  @ViewChild('descripcionTipoLicitacionHeaderTemplate', {static: true}) public descripcionTipoLicitacionHeaderTemplate: TemplateRef<any>;
  @ViewChild('descripcionTipoLicitacionEstadoEditorTemplate', {static: true}) public descripcionTipoLicitacionEstadoEditorTemplate: TemplateRef<any>;
  @ViewChild(IgxGridStateDirective, {static: true}) public state;
  // Grid Layout
  public mObjConfigGrids: ClsObjConfiguracionGrid = new ClsObjConfiguracionGrid();
  // ConfigGridLayout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };
  public vtnGenerico: VtnGenericaComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.gridTiposDeLicitaciones.data = [];
  }

  public ngAfterViewInit() {
    // se genera la plantilla default del grid
    const stateDefault = this.state.getState(true);

    this.mObjConfigGrids.saveGridState(EnumNombresGrids.TiposLicitaciones, true, stateDefault, '', this.clicked);
    const state = this.mObjConfigGrids.initGridState(EnumNombresGrids.TiposLicitaciones);
    if (!ClsUtil.esNulo(state[0])) {
      this.state.setState(state[0]);
    }
    this.clicked = state[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public onColumnInit(column: IgxColumnComponent) {
    switch (column.field) {
      case 'TipoLicitacion':
        column.headerTemplate = this.tipoLicitacionHeaderTemplate;
        column.inlineEditorTemplate = this.tipoLicitacionEditorTemplate;
        column.summaries = this.summaryPipe.transform('filasSummary');
        break;
      case 'DescripcionTipoLicitacion':
        column.headerTemplate = this.descripcionTipoLicitacionHeaderTemplate;
        column.inlineEditorTemplate = this.descripcionTipoLicitacionEstadoEditorTemplate;
        break;
    }
    // column.cellClasses = this.backgroundClasses;
  }

  public async cargarTiposDeLicitaciones() {
    if (!ClsUtil.esNulo(this.infPpto.organizacion)) {
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
        this.mObjCRUDCatalogos.dataCatalogo = [];
        this.dataTiposDeLicitaciones = [];
        await this.mObjCRUDCatalogos.obtenerCatalogo(0, 'ConsultarTiposLicitacion2021');
        this.mObjCRUDCatalogos.dataCatalogo.forEach(item => {
          const tipo: ClsTipoLicitaciones = {
            IdTipoLicitacion: item.IdTipoLicitacion,
            TipoLicitacion: item.TipoLicitacion,
            DescripcionTipoLicitacion: item.DescripcionTipoLicitacion,
          };
          this.dataTiposDeLicitaciones.push(tipo);
        });
        this.gridTiposDeLicitaciones.data = this.dataTiposDeLicitaciones;
        this.errorAlCargar = false;
        this.tipoMsg.cerrarWaitDialog();
      } catch (e) {
        this.tipoMsg.cerrarWaitDialog();
        this.errorAlCargar = true;
        this.tipoMsg.mostrarMsg(e.message, 'error');
      }
    }
  }

  public menuContextual(evt: any) {
    evt.event.preventDefault();
    this.disableContextMenu();
    this.disableAllContextMenu();
    this.menus = this.mObjCRUDCatalogos.crearMenuContextual({
      esCliente: false,
      esUnidad: false,
      esEmpresa: false
    }, this.infPpto.esPptoMaestro);
    this.subMenusOpciones = [];
    this.lengthMenu = this.menus.filter(x => !x.disabled).length;
    this.contextmenuX = ClsUtil.calcPosition(document.body.clientWidth, evt.event.clientX, true, this.lengthMenu);
    this.contextmenuY = ClsUtil.calcPosition(document.body.clientHeight, evt.event.clientY, false, this.lengthMenu);
    this.sizeMenu = (this.lengthMenu * 37) + 'px';
    this.cellMenuContextaul = evt.cell;
    this.verContextMenu = true;
  }

  public disableContextMenu() {
    if (this.verContextMenu) {
      this.verContextMenu = false;
    }
  }

  public disableAllContextMenu() {
    this.mObjGenerico.disableAllContextMenu(this.infPpto);
  }

  public async accionSeleccionada(evt: INeodataGridCell) {
    try {
      switch (evt.accionMenu.id) {
        case EnumMCGenerales.Copiar:
          await this.copiarData();
          break;
        case EnumMCGenerales.Pegar:
          let data: any = await navigator.clipboard.readText().then((data2) => data2);
          data = this.pasteHandlerNeo.processData(data);
          await this.datosPegadosDesdeExcel(data);
          break;
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMCGenerales.GuardarLayout:
          const state = this.state.getState(true);
          this.mObjConfigGrids.saveGridState(EnumNombresGrids.TiposLicitaciones, false, '', state, !this.clicked);
          break;
        case EnumMCGenerales.ReestablecerLayout:
          this.restoreGrid();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public restoreGrid() {
    const stateDefault = this.mObjConfigGrids.restoreGrid(EnumNombresGrids.TiposLicitaciones);
    if (!ClsUtil.esNulo(stateDefault[0])) {
      this.state.setState(stateDefault[0]);
    }
    this.clicked = stateDefault[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridTiposDeLicitaciones.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridTiposDeLicitaciones.filteringLogic = FilteringLogic.Or;
    this.gridTiposDeLicitaciones.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public rowEditEnter() {
    this.showActionStrip = false;
  }

  public rowEditExit() {
    this.showActionStrip = true;
  }

  // evento que se ocupa para guardar o modificar
  public async addUpdateTipoDeLicitacion(tipoDeLicitacion: IGridEditDoneEventArgs) {
    const newValor: ClsTipoLicitaciones = tipoDeLicitacion.newValue;
    const oldValor: ClsTipoLicitaciones = tipoDeLicitacion.oldValue;
    if (tipoDeLicitacion.isAddRow) {
      await this.agregarModificarTipoDeLicitacion(newValor, oldValor, tipoDeLicitacion.isAddRow);
    } else {
      // al editar los campos, validar que sean distintos para ocupar el servicio
      if (this.mObjCRUDCatalogos.validarSiCambioCamposCatalogos(newValor, oldValor, EnumTresPuntos.TiposDeLicitaciones)) {
        await this.agregarModificarTipoDeLicitacion(newValor, oldValor, tipoDeLicitacion.isAddRow);
      }
    }
  }

  private async agregarModificarTipoDeLicitacion(newTipoDeLicitacion: ClsTipoLicitaciones, oldTipoDeLicitacion: ClsTipoLicitaciones, isAddRow: boolean) {
    let respuesta: bigint;
    const objCatalogo: ClsTipoLicitaciones = new ClsTipoLicitaciones();
    try {
      // objCatalogo.IdTipoLicitacionSql = isAddRow ? ClsUtil.parseJSONBig(0) : newTipoDeLicitacion.IdTipoLicitacionSql;
      objCatalogo.IdTipoLicitacion = isAddRow ? ClsUtil.parseJSONBig(0) : newTipoDeLicitacion.IdTipoLicitacion;
      objCatalogo.TipoLicitacion = newTipoDeLicitacion.TipoLicitacion.toUpperCase();
      objCatalogo.DescripcionTipoLicitacion = newTipoDeLicitacion.DescripcionTipoLicitacion;
      this.tipoMsg.mostrarWaitDialog(isAddRow ? 'MENSAJES.WAIT.GUARDANDO_CATALOGO' : 'MENSAJES.WAIT.MODIFICANDO_CATALOGO');
      respuesta = await this.mObjCRUDCatalogos.agregarModificarCatalogo([objCatalogo], 'TiposLicitacionRegistraActualiza2021');
      if (isAddRow) {
        newTipoDeLicitacion.IdTipoLicitacion = respuesta;
      }
      this.tipoMsg.mostrarToast(isAddRow ? 'MENSAJES.TOAS.GUARDANDO_CATALOGO' : 'MENSAJES.TOAS.MODIFICANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.cancelarAddUpdateTiposDeLicitaciones(newTipoDeLicitacion, oldTipoDeLicitacion, isAddRow);
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa cuando manda error al intentar agregar o modificar,
  // al agregar si manda error se quita la fila del grid
  // al editar si manda error se regresa a los valores anteriores
  private cancelarAddUpdateTiposDeLicitaciones(newTipoDeLicitacion: ClsTipoLicitaciones, oldTipoDeLicitacion: ClsTipoLicitaciones, isAddRow: boolean) {
    if (isAddRow) {
      this.gridTiposDeLicitaciones.deleteRowById(newTipoDeLicitacion.IdTipoLicitacion);
    } else {
      this.gridTiposDeLicitaciones.updateRow(oldTipoDeLicitacion, oldTipoDeLicitacion.IdTipoLicitacion);
    }
  }

  private async eliminarTipoDeLicitacion(rowContext: RowType) {
    const tipoDeLicitacion: ClsTipoLicitaciones = rowContext.data;
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.ELIMINANDO_CATALOGO', undefined, 'delete');
      await this.mObjCRUDCatalogos.eliminarCatalogo(tipoDeLicitacion.IdTipoLicitacion, 'EliminarTiposLicitacion2021');
      this.gridTiposDeLicitaciones.getRowByIndex(rowContext.index).delete();
      this.tipoMsg.mostrarToast('MENSAJES.TOAS.ELIMINANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa el evento rowEdit para validar uno o varios campos obligatorios,
  // si falta algun campo de toda la fila se cancela la edicion y se manda mensaje de que campos faltan
  // en caso de ser todo OK, procede al agregado o modificado
  public validarTipoDeLicitacion(tipoDeLicitacion: IGridEditEventArgs) {
    const valor: ClsTipoLicitaciones = tipoDeLicitacion.newValue;
    tipoDeLicitacion.cancel = this.esValido(valor, tipoDeLicitacion, tipoDeLicitacion.isAddRow);
  }

  // en este caso se pasa el valor de la unidad, ya que es el unico campo obligatorio,
  // en caso de ser mas campos a validar, pasar toda la clase
  private esValido(tiposDeLicitaciones: ClsTipoLicitaciones, tipoLic: any, isAddRow: boolean): boolean {
    // validar campos obligatorios
    if (ClsUtil.esNulo(tiposDeLicitaciones.TipoLicitacion)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.TIPOS_LICITACION.COL_TIPO')));
      return true;
    }

    if (ClsUtil.esNulo(tiposDeLicitaciones.DescripcionTipoLicitacion)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.TIPOS_LICITACION.COL_DESCRIPCION')));
      return true;
    }
    // valida si ya existe la empresa cuando se agrega o modifica
    if (isAddRow) {
      if (this.dataTiposDeLicitaciones.findIndex(tipoDeLicitacion => tipoDeLicitacion.TipoLicitacion === tiposDeLicitaciones.TipoLicitacion) !== -1) {
        this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(tiposDeLicitaciones.TipoLicitacion));
        return true;
      }
    } else {
      if (tiposDeLicitaciones.TipoLicitacion !== tipoLic.oldValue.TipoLicitacion) {
        if (this.dataTiposDeLicitaciones.findIndex(tipoDeLicitacion => tipoDeLicitacion.TipoLicitacion === tiposDeLicitaciones.TipoLicitacion) !== -1) {
          this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(tiposDeLicitaciones.TipoLicitacion));
          return true;
        }
      }
    }
    return false;
  }

  public accionStripRowBtn(rowContext: RowType, indexBtn: number) {
    try {
      switch (indexBtn) {
        case 1:
          this.beginAddRowByIndexNeo(this.gridTiposDeLicitaciones, rowContext.index);
          break;
        case 2:
          this.tipoMsg.mostrarQuestion((resp: boolean) => {
            if (resp) {
              this.eliminarTipoDeLicitacion(rowContext);
            }
          }, this.mObjGenerico.getTranslationsQuestionBorrar(rowContext.data.TipoLicitacion));
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridTiposDeLicitaciones, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.TIPO_LICITACIONES'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridTiposDeLicitaciones.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridTiposDeLicitaciones,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.TIPO_LICITACIONES'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.Actualizar:
          await this.cargarTiposDeLicitaciones();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public handleRowSelection() {
    this.gridTiposDeLicitaciones.nativeElement.focus();
  }

  public async datosPegadosDesdeExcel(datosPegado: any[]) {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.PEGANDO');
      let arrayTipoLic: ClsTipoLicitaciones[] = [];
      let dataDetalle: ClsColDetallePegado[];
      const colTipo: string = this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_LICITACION.COL_TIPO');
      const colDes: string = this.mObjGenerico.getTranslationsSubject('GRIDS.TIPOS_LICITACION.COL_DESCRIPCION');
      this.mObjCopiado.columnasRequeridas = [colTipo, colDes];
      if (this.mObjCopiado.validarCamposRequeridos(datosPegado)) {
        let datos = this.mObjCopiado.procesarDatos(datosPegado, true);
        datos = this.mObjPegado.mergeDescriptions(datos, EnumNombresGrids.TiposLicitaciones);
        dataDetalle = this.mObjPegado.verificarDetallePegado(datos, [colTipo, colDes], [colTipo, colDes], EnumNombresGrids.TiposLicitaciones, this.mObjGenerico);
        if (dataDetalle.length > 0) {
          const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
          vtnGenerico.queVtnEstaAbierta = 'PegadoEspecial';
          const vtnDiferencia = vtnGenerico.crearComponente(DetallePegadoComponent);
          vtnDiferencia.dataDetalle = dataDetalle;
          vtnDiferencia.open();
        } else {
          datos.forEach(x => {
            const valTipo: string = (x[colTipo] as string).toUpperCase();
            // validamos la cadena, si es undifine o null, le asignamos '' en caso contrario el valor
            // esto se hace porque la columna descripcion no es obligado, puede venir o no
            const valDes: string = ClsUtil.toSubstring(x[colDes] as string, 40);
            const resp: any = this.mObjCRUDCatalogos.crearObjCatalogos(this.dataTiposDeLicitaciones, [valTipo, valDes], [colTipo, colDes], EnumTresPuntos.TiposDeLicitaciones, this.mObjGenerico);
            if (!ClsUtil.esNulo(resp.esNuevo)) {
              if (resp.esNuevo) {
                arrayTipoLic.push(resp.obj);
              } else {
                this.gridTiposDeLicitaciones.updateCell(valDes, resp.obj.IdTipoLicitacion, 'DescripcionTipoLicitacion');
                arrayTipoLic.push(resp.obj);
              }
            }
          });
          // invocar servicio para agregar o modificar siempre y cuando el arrayUnidades tenga valor
          if (arrayTipoLic.length > 0) {
            const respuesta: any = await this.mObjCRUDCatalogos.agregarModificarCatalogo(arrayTipoLic, 'TiposLicitacionRegistraActualiza2021', false);
            // filtro los registros con id 0
            arrayTipoLic = arrayTipoLic.filter(value => value.IdTipoLicitacion === BigInt(0));
            // iteramos la respuesta para ir asignando los ids para los registros nuevos
            const key: string[] = Object.keys(respuesta);
            key.forEach(x => {
              const lic: ClsTipoLicitaciones = arrayTipoLic.find(value1 => value1.TipoLicitacion === x);
              if (!ClsUtil.esNulo(lic)) {
                lic.IdTipoLicitacion = ClsUtil.bigintX(respuesta[x]);
                this.gridTiposDeLicitaciones.addRow(lic);
              }
            });
          }
        }
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public async customKeydown(eventArgs) {
    const ctrl = eventArgs.ctrlKey;
    const key = eventArgs.keyCode;
    // Ctrl-C ||  Cmd-C
    if ((ctrl || eventArgs.metaKey) && key === 67) {
      await this.copiarData();
    }
  }

  public async copiarData() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.COPIANDO');
      const msg: string = await ClsUtil.copiarDatosGrids(this.gridTiposDeLicitaciones, 'IdTipoLicitacion', this.mObjGenerico);
      msg && this.tipoMsg.mostrarToast(msg);
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public clearProps() {
    this.gridTiposDeLicitaciones.clearSort();
    this.gridTiposDeLicitaciones.clearFilter();
    this.gridTiposDeLicitaciones.clearSearch();
    this.gridTiposDeLicitaciones.deselectAllRows();
    this.clearInput();
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridTiposDeLicitaciones.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridTiposDeLicitaciones.getRowData(rowSeleccionados[0]);
      this.gridTiposDeLicitaciones.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
